export enum EntityNameType {
  Project = 'project',
  Module = 'module',
  Connection = 'connection',
}

